import { useMutation, useQueryClient } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth.ts';
import { RoutingMappings } from 'schemas/RoutingPlan.schema';
import { apiFetch } from 'utils/apiUtils.ts';

interface UpdateTeamRoutingPlansVariables {
  teamId: string;
  routingMappings: RoutingMappings;
}

interface UpdateTeamRoutingPlansResponse {
  message: string;
}

export default function useUpdateTeamRoutingPlans() {
  const { tokens } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['teamRoutingPlans'],
    mutationFn: async ({ teamId, routingMappings }: UpdateTeamRoutingPlansVariables) => apiFetch<UpdateTeamRoutingPlansResponse>({
      path: `team/${teamId}/routing`,
      method: 'POST',
      accessToken: String(tokens.accessToken),
      body: routingMappings,
    }),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['teamRoutingPlans', { teamId: variables.teamId }],
      });
    },
  });
}
